/**
 * @generated SignedSource<<d8ca6ab9dd29b7ed6b0e88277650ab06>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMakeOfferButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedContactDealerWrapper_user">;
  readonly " $fragmentType": "PdpSharedMakeOfferButton_user";
};
export type PdpSharedMakeOfferButton_user$key = {
  readonly " $data"?: PdpSharedMakeOfferButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMakeOfferButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMakeOfferButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "247104b797c433c1faa85768d6235e67";

export default node;
